/* global wc_cart_params */
/* global store_credit_params */

export default {
  init() {
    initializeMaintenanceProductsModal();
  },
  finalize() {
    coupon_ajax();
    show_coupon_button();
    updateCart();

    $(document.body).on('updated_cart_totals', function() {
      initializeMaintenanceProductsModal();
    });
  },
};

export var initializeMaintenanceProductsModal = () => {
  let maintenanceProductsModal = $('.maintenance-products-modal').wsModal();

  $(document).off('click', '.show-maintenance').on('click', '.show-maintenance', function () {
    maintenanceProductsModal.wsModal('open');
    $('.maintenance-products h2 .product-name').text($(this).attr('data-product'));
    $('.maintenance-products-content').empty();
    $('.maintenance-products-content').append($(this).closest('.wolky-cart-item').find('.product-maintenance-products').html());
  });
};

export var coupon_ajax = () => {
  $(document).on('click', '#coupon_code_button', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    let coupon_code = $('#coupon_code').val();
    apply_coupon(coupon_code);
  });
};

export var show_coupon_button = () => {
  $(document).on('focus', '#coupon_code', function () {
    $(document).on('keypress', '#coupon_code', function (e) {
      if (e.which === 13) {
        e.preventDefault();
        e.stopImmediatePropagation();
        let coupon_code = $('#coupon_code').val();
        apply_coupon(coupon_code);
      }
    });
  });

  $(document).on('click', '.coupon_form .coupon_form_toggle', function () {
    $(this).parent().toggleClass('open');
  });
};

export var apply_coupon = (coupon_code) => {
  $.ajax({
    type: 'POST',
    url: store_credit_params.wc_ajax_url.replace('%%endpoint%%', 'ws_apply_coupon'),
    data: {
      'coupon_code': coupon_code,
      'security': wc_cart_params.apply_coupon_nonce,
    },
  })
    .done(function(response) {
      if (response.data !== true) {
        console.log('Invalid coupon:', response);
      }
      $(document.body).trigger('wc_update_cart');
    })
    .fail(function() {
      $(document.body).trigger('wc_update_cart');
    });
};

export var updateCart = () => {
  $(document).on('click', '.quantity-input-price .plus, .quantity-input-price .minus', function () {
    const $inputField = $(this).closest('.quantity-input-price').find('input.qty');
    const currentValue = parseInt($inputField.val()) || 0;
    const step = parseInt($inputField.attr('step')) || 1;
    const min = parseInt($inputField.attr('min')) || 0;
    const max = parseInt($inputField.attr('max')) || 9999;
    let newValue;

    if ($(this).hasClass('plus')) {
      newValue = currentValue + step;
      if (newValue > max) newValue = max;
    } else {
      newValue = currentValue - step;
      if (newValue < min) newValue = min;
    }

    $inputField.val(newValue).trigger('input');
  });

  $(document).on('input', '.quantity-input-price input.qty', function () {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    const $inputField = $(this);
    const $productQuantityBlock = $inputField.closest('.product-quantity');

    this.debounceTimer = setTimeout(() => {
      const cart_item_key_match = $inputField.attr('name').match(/cart\[(\w+)\]/);
      if (!cart_item_key_match) return;

      const cart_item_key = cart_item_key_match[1];
      const new_qty = $inputField.val();
      const nonce = $productQuantityBlock.data('nonce');

      $inputField.closest('.wolky-cart-item').addClass('processing');

      $.ajax({
        type: 'POST',
        url: store_credit_params.wc_ajax_url.replace('%%endpoint%%', 'wolky_update_cart_item_quantity'),
        data: {
          cart_item_key: cart_item_key,
          new_qty: new_qty,
          security: nonce,
        },
        success: function (response) {
          if (response.success) {
            $(document.body).trigger('wc_update_cart');
          } else {
            console.error('Failed to update cart:', response.data.message);
            $inputField.closest('.wolky-cart-item').removeClass('processing');
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.error('AJAX Error:', textStatus, errorThrown);
          $inputField.closest('.wolky-cart-item').removeClass('processing');
        },
      });
    }, 1000);
  });
};
